import script from "./PlayerDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerDetails.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__